var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('el-upload', _vm._g(_vm._b({ ref: "uploader", staticClass: "common-uploader", attrs: { "accept": _vm.accept, "action": _vm.action, "headers": _vm.getHeaders() } }, 'el-upload', _vm.$attrs, false), _vm.$listeners), [_vm._t("default", null, { "slot": "default" }), _vm._v(" "), _vm._t("tip", null, { "slot": "tip" }), _vm._v(" "), _vm._t("trigger", null, { "slot": "trigger" })], 2);
};
var staticRenderFns = [];

export { render, staticRenderFns };